import * as React from 'react';
import { Controller, FieldPath, FieldValues, useFormContext } from 'react-hook-form';
import { cn } from '@/lib/utils';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

interface SwitchFieldProps {
  name: string;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
}

export const SwitchField = React.forwardRef<HTMLButtonElement, SwitchFieldProps>(
  (
    {
      name,
      label,
      disabled = false,
      required = false,
      className,
    },
    ref
  ) => {
    const { control, formState: { errors } } = useFormContext();
    const error = errors[name];

    return (
      <div className={cn('flex items-center space-x-2', className)}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Switch
              id={name}
              checked={field.value}
              onCheckedChange={field.onChange}
              disabled={disabled}
            />
          )}
        />
        {label && (
          <Label
            htmlFor={name}
            className={cn(
              'text-sm font-medium leading-none cursor-pointer',
              error && 'text-destructive'
            )}
          >
            {label}
            {required && <span className="text-destructive ml-1">*</span>}
          </Label>
        )}
        {error && (
          <p className="text-sm text-destructive">{String(error.message)}</p>
        )}
      </div>
    );
  }
);

SwitchField.displayName = 'SwitchField';

export default SwitchField;
